import type { LibraryTopicBrandRule } from '@digital-twins/shared-types'

/** The backend's LIBRARY_RULE_VALUES_MAX. Groups are admitted whole. */
export const COLLECTION_RULE_VALUES_MAX = 50

/** Stable pair identity; neither part is interpreted or rewritten. */
export function topicBrandKey(pair: LibraryTopicBrandRule): string {
  return `${pair.topicToken}:${pair.brandId}`
}

export function addedRuleTokens(selected: Array<string>, group: Array<string>): Array<string> | null {
  const next = [...new Set([...selected, ...group])]
  return next.length <= COLLECTION_RULE_VALUES_MAX ? next : null
}
